import type { EventHandler } from './dom-events';

class EventHandlerList {
  constructor(private handlers: EventHandler[]) {
  }

  start() {
    this.handlers.forEach((handler) => handler.start());
    return this;
  }

  stop() {
    this.handlers.forEach((handler) => handler.stop());
    return this;
  }

  destroy() {
    this.handlers.forEach((handler) => handler.destroy());
    return this;
  }
}

export default EventHandlerList;
